import { Routes, Route } from 'react-router-dom';
import App from './App'; // Ensure the path is correct based on your project structure // Ensure the path is correct based on your project structure
import UserManager from './components/userManager/UserManager';

function MainRouter() {
    return (
        <Routes>
            <Route path="/*" element={<App />} />
            <Route path="/login" element={<UserManager />} />
            <Route path="/signup" element={<UserManager />} />
            <Route path="/reset-password" element={<UserManager />} />
            <Route path="/verify" element={<UserManager />} />
        </Routes>
    );
}

export default MainRouter;
